import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRelationsListStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        entity: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            minWidth: 0,
        },
        entityIcon: {
            display: "flex",
            "& svg": {
                width: theme.customSpacing.menuIconSize,
                height: theme.customSpacing.menuIconSize,
                fill: "#DAD9EF",
            },
        },
    });
};
